/**
 * Strings that should be displayed as regular bullet point list in the data
 * explorer
 */
export class MetadataList {

    constructor(public readonly lines: ReadonlyArray<string>) { }
}
